module.exports = __webpack_public_path__ + "img/cari_en.da029f0d.svg";